const PostType = {
  POST: 'post',
  REELS: 'reels',
  SHORTS: 'shorts',
  STORY: 'story',
  VIDEO: 'video',
  DIRECT_POST: 'DIRECT_POST',
  UPLOAD_TO_INBOX: 'UPLOAD_TO_INBOX',
  STANDARD: 'STANDARD',
  OFFER: 'OFFER',
  EVENT: 'EVENT',
  PUBLIC_STORY: 'PUBLIC_STORY',
  SAVED_STORY: 'SAVED_STORY',
  SPOTLIGHT: 'SPOTLIGHT',
  EVENT: 'EVENT',
};

const MediaType = {
  VIDEO: 'video',
  IMAGE: 'image',
  PHOTO: 'photo',
  DOCUMENT: 'document',
};
const ServiceName = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  LINKEDIN: 'LINKEDIN',
  TIKTOK: 'TIKTOK',
  GBUSINESS: 'GBUSINESS',
  PINTEREST: 'PINTEREST',
  THREADS: 'THREADS',
  BLUESKY: 'BLUESKY',
  SNAPCHAT:'SNAPCHAT'
};
const getDefaultPostType = (servicename) => {
  switch (servicename.toUpperCase()) {
    case ServiceName.FACEBOOK:
      return PostType.POST;
    case ServiceName.INSTAGRAM:
      return PostType.POST;
    case ServiceName.TWITTER:
      return PostType.POST;
    case ServiceName.YOUTUBE:
      return PostType.VIDEO;
    case ServiceName.LINKEDIN:
      return PostType.POST;
    case ServiceName.TIKTOK:
      return PostType.DIRECT_POST;
    case ServiceName.GBUSINESS:
      return PostType.STANDARD;
    case ServiceName.PINTEREST:
      return PostType.POST;
    default:
      return PostType.POST; // Fallback to POST for unknown services
  }
};
const DisplayName = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  LINKEDIN: 'LINKEDIN',
  TIKTOK: 'TIKTOK',
  GBUSINESS: 'GOOGLE MY BUSINESS',
};
const RecentPostServiceName = {
  FACEBOOK: 'facebook_service',
  INSTAGRAM: 'instagram_service',
  TWITTER: 'twitter_service',
  YOUTUBE: 'youtube_service',
  LINKEDIN: 'linkedIn_service',
  TIKTOK: 'tiktok_service',
  GBUSINESS: 'gbusiness_service',
  PINTEREST: 'pinterest_service',
  THREADS: 'threads_service',
  BLUESKY: 'bluesky_service',
  SNAPCHAT: 'snapchat_service',
};

const DashboardProfileServiceName = {
  FACEBOOK: 'dashboard_facebook_profile_stats',
  INSTAGRAM: 'dashboard_instagram_profile_stats',
  TWITTER: 'dashboard_twitter_profile_stats',
  THREADS: 'dashboard_threads_profile_stats',
  BLUESKY: 'dashboard_bluesky_profile_stats',
  YOUTUBE: 'dashboard_youtube_profile_stats',
  LINKEDIN: 'dashboard_linkedin_profile_stats',
  TIKTOK: 'dashboard_tiktok_profile_stats',
  GBUSINESS: 'dashboard_gbusiness_profile_stats',
  PINTEREST: 'dashboard_pinterest_profile_stats',
  SNAPCHAT: 'dashboard_snapchat_profile_stats',
};
const ProfileType = {
  PAGE: 'PAGE',
  GROUP: 'GROUP',
  PROFILE: 'PROFILE',
  DIRECT_PROFILE: 'DIRECT PROFILE',
  DEVELOPER: 'DEVELOPER',
};
const SupportedFileFormat = [
  'video/mp4',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
const TikTokPrivacyLevel = {
  PUBLIC_TO_EVERYONE: 'PUBLIC_TO_EVERYONE',
  MUTUAL_FOLLOW_FRIENDS: 'MUTUAL_FOLLOW_FRIENDS',
  FOLLOWER_OF_CREATOR: 'FOLLOWER_OF_CREATOR',
  SELF_ONLY: 'SELF_ONLY',
};
const YoutubePrivacyLevel = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  UNLISTED: 'unlisted',
};
const TikTokOptions = {
  DISABLE_DUET: 'disable_duet',
  DISABLE_COMMENT: 'disable_comment',
  DISABLE_SWITCH: 'disable_switch',
  BRAND: 'your_brand',
  BRAND_CONTENT: 'brand_content',
  DISCLOSURE_CONTENT: 'disclosure_content',
};
const ServiceConfigurations = {
  FACEBOOK: {
    REELS: {
      MINSECONDS: 3, // 3 Seconds
      MAXSECONDS: 90, // 90 Seconds
      MAXWIDTH: 1920,
      MAXHEIGHT: 1920,
      MINWIDTH: 540,
      MINHEIGHT: 960,
      DESCRIPTION_MAX: 5000,
      MAXASPECTRATIO: 9 / 16,
      ASPECTRATIO: '9:16',
    },
    POST: {
      MAXSECONDS: 1800, // 30 Minute
      DESCRIPTION_MAX: 5000,
      MINWIDTH: 120,
      MINHEIGHT: 120,
      MAXWIDTH: 30000,
      MAXHEIGHT: 30000,
      MAX_IMAGE_SIZE_MB: 4,
      MAX_VIDEO_SIZE_MB: 1000,
      MAXIMAGECOUNT: 10,
      ASPECTRATIO: '9:16',
    },
    STORY: {
      MINSECONDS: 3, // 3 Seconds
      MAXSECONDS: 60, // 60 Seconds
      MAXWIDTH: 1920,
      MAXHEIGHT: 1920,
      MINWIDTH: 540,
      MINHEIGHT: 960,
      MAX_IMAGE_SIZE_MB: 4,
      IMAGEMAXWIDTH: 30000,
      IMAGEMAXHEIGHT: 30000,
      MAXASPECTRATIO: 9 / 16,
      ASPECTRATIO: '9:16',
    },
  },
  INSTAGRAM: {
    REELS: {
      MAXSECONDS: 900, // 90 Seconds
      MINSECONDS: 3, // 3 Seconds
      MAXWIDTH: 1920,
      DESCRIPTION_MAX: 2200,
      MAX_VIDEO_SIZE_MB: 1000,
      MAX_IMAGE_SIZE_MB: 8,
      ASPECTRATIO: '9:16',
    },
    POST: {
      MAXSECONDS: 900, // 12 Hours
      MINSECONDS: 3,
      VIDEOLENGTH: 60,
      DESCRIPTION_MAX: 2200,
      MAXIMAGECOUNT: 10,
      MINWIDTH: 320,
      MAXWIDTH: 1440,
    },
    STORY: {
      MINSECONDS: 3, // 3 Seconds
      MAXSECONDS: 60, // 60 Seconds
      MAXWIDTH: 1920,
      MAXHEIGHT: 1920,
      MAX_IMAGE_SIZE_MB: 8,
      MAX_VIDEO_SIZE_MB: 100,
      MIN_IMAGE_ASPECT_RATIO: 0.8,
      MAX_IMAGE_ASPECT_RATIO: 1.91,
      MIN_VIDEO_ASPECT_RATIO: 0.01,
      MAX_VIDEO_ASPECT_RATIO: 10,
      ASPECTRATIO: '9:16',
    },
  },
  SNAPCHAT: {
  COMMON: {
    MAX_MEDIA_COUNT: 1,           // All Snapchat post types support only 1 media
    VIDEO: {
      MIN_SECONDS: 5,
      MAX_SECONDS: 300,
      MIN_WIDTH: 540,
      MIN_HEIGHT: 960,
    },
    IMAGE: {
      MIN_WIDTH: 540,     // Recommended only
      MIN_HEIGHT: 960,    // Recommended only
    },
    DESCRIPTION_MAX: 2200,        // Default for stories
  },

  PUBLIC_STORY: {
    DESCRIPTION_MAX: 2200,
  },
  SAVED_STORY: {
    TITLE_MAX: 40,
    DESCRIPTION_MAX: 2200,
  },
  SPOTLIGHT: {
    DESCRIPTION_MAX: 160,
  },
},
  YOUTUBE: {
    COMMON: {
      TITLE_MAX: 100,
      DESCRIPTION_MAX: 5000,
    },
    SHORTS: {
      MAXSECONDS: 180, // 180 Seconds
      ASPECTRATIO: '9:16',
    },
    POST: {
      MAXSECONDS: 3600, // 1 Hours
      MAX_VIDEO_SIZE_MB: 5000,
    },
  },
  TWITTER: {
    POST: {
      MAXIMAGECOUNT: 4,
      MAXSECONDS: 140,
      MINSECONDS: 1,
      MAXWIDTH: 4096,
      MAXHEIGHT: 4096,
      MINWIDTH: 32,
      MINHEIGHT: 32,
      IMAGE_MAXWIDTH: 8192,
      IMAGE_MAXHEIGHT: 8192,
      IMAGE_MINWIDTH: 4,
      IMAGE_MINHEIGHT: 4,
      MAX_VIDEO_SIZE_MB: 512,
      MAX_IMAGE_SIZE_MB: 5,
    },
  },
  THREADS: {
    POST: {
      MAX_DESCRIPTION_CHARS: 500, // Threads allows up to 1000 chars
      MAX_TOTAL_MEDIA: 20, // Carousel limit
      MIN_CAROUSEL_ITEMS: 2, // Carousel needs ≥2 items
      IMAGE_FORMATS: ['JPEG', 'PNG'], // Officially supported
      VIDEO_CONTAINERS: ['MP4', 'MOV'], // Required containers

      IMAGE_MAX_SIZE_MB: 8, // 8 MB per image
      IMAGE_MIN_WIDTH: 320, // Will be scaled up
      IMAGE_MAX_WIDTH: 1440, // Will be scaled down

      VIDEO_MAX_SIZE_MB: 1024, // 1 GB = 1024 MB
      VIDEO_MAX_DURATION_SEC: 300, // 5 min
      VIDEO_MIN_DURATION_SEC: 0.01, // >0 sec
      VIDEO_MAX_WIDTH: 1920, // Max horizontal pixels
      VIDEO_MAX_HEIGHT: 1920, // (square‑ish recommendation)
      VIDEO_MIN_FPS: 23,
      VIDEO_MAX_FPS: 60,
      VIDEO_MAX_BITRATE_MBPS: 100,
      AUDIO_MAX_BITRATE_KBPS: 128,
      ASPECT_RATIO_MIN: 0.01, // 0.01:1
      ASPECT_RATIO_MAX: 10, // 10:1
    },
  },
  BLUESKY: {
    POST: {
        MAX_DESCRIPTION_CHARS: 300,        // Hard limit by Bluesky
        MAX_IMAGES: 4,                     // Max 4 images in carousel
        MAX_VIDEOS: 1,                     // Only 1 video allowed
        IMAGE_MAX_SIZE_BYTES: 8000000,     // 1 MB strict limit
        VIDEO_MAX_SIZE_MB: 100,             // Recommended max
        VIDEO_MAX_DURATION_SEC: 60,        // Safe limit (up to 120 possible but risky)
        SUPPORTED_IMAGE_FORMATS: ['JPEG', 'PNG'],
        SUPPORTED_VIDEO_FORMATS: ['MP4'],
        ASPECT_RATIO_MIN: 0.1,             // Very flexible
        ASPECT_RATIO_MAX: 10,
    },
  },
  PINTEREST: {
    POST: {
      MAXIMAGECOUNT: 1,
      MINWIDTH: 75,
      MINHEIGHT: 75,
      DESCRIPTION_MAX: 800,
      TITLE_MAX: 100,
      MAX_VIDEO_SIZE_MB: 1000,
      MAX_IMAGE_SIZE_MB: 20,
    },
  },
  LINKEDIN: {
    POST: {
      MAXIMAGECOUNT: 20,
      MAXSECONDS: 600,
      MAXWIDTH: 4096,
      MAXHEIGHT: 2304,
      MINWIDTH: 256,
      MINHEIGHT: 144,
      DESCRIPTION_MAX: 3000,
      ALTER_TEXT_MAX: 3000,
      MAX_VIDEO_SIZE_MB: 200,
      MAX_DOCUMENT_SIZE_MB: 100,
    },
  },
  GBUSINESS: {
    POST: {
      MAXIMAGECOUNT: 1,
      MAXWIDTH: 3000,
      MAXHEIGHT: 3000,
      MINWIDTH: 500,
      MINHEIGHT: 500,
      MAX_IMAGE_SIZE_MB: 5,
      MIN_IMAGE_SIZE_KB: 10,
    },
  },
  TIKTOK: {
    POST: {
      IMAGE: {
        MAXIMAGECOUNT: 10,
        ASPECTRATIO: ['9:16', '3:4'],
        MINWIDTH: 360,
        MINHEIGHT: 360,
        FILESIZE: 20,
      },
      VIDEO: {
        MAXWIDTH: 4096,
        MAXHEIGHT: 4096,
        MINWIDTH: 360,
        MINHEIGHT: 360,
        MINSECONDS: 1,
        MAXSECONDS: 600,
        ACTIONMAXSECONDS: 60,
        ASPECTRATIO: ['9:16', '3:4', '1:1', '16:9'],
      },
      MAX_VIDEO_SIZE_MB: 1000,
      DESCRIPTION_MAX: 2200,
      TITLE_MAX: 90,
    },
  },
};
export const PostUtil = {
  PostType,
  ServiceName,
  DisplayName,
  getDefaultPostType,
  RecentPostServiceName,
  DashboardProfileServiceName,
  SupportedFileFormat,
  ServiceConfigurations,
  ProfileType,
  TikTokPrivacyLevel,
  YoutubePrivacyLevel,
  MediaType,
  TikTokOptions,
};
